import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoleService } from '../../shared/services/role.service';

/**
 * Restricts a route to users with an elevated role (Admin / Super Admin).
 * Unauthorized users are sent back to the standard dashboard.
 *
 * This is a UX guard only — the backing APIs must enforce authorization too.
 */
export const adminGuard: CanActivateFn = () => {
  const roleService = inject(RoleService);
  const router = inject(Router);

  return roleService.canAccessAdmin() ? true : router.createUrlTree(['/dashboard']);
};
